export default __webpack_public_path__ + "static/type-writer-59d59f73339988721dfe4bc9247cb0ff.png";